import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center space-y-8">
        <XCircle className="w-20 h-20 mx-auto mb-6 text-red-600" />
        <h1 className="luxury-text text-3xl font-medium mb-4 text-red-600" data-testid="payment-cancel-message">Payment Cancelled</h1>
        <p className="text-slate-800 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="rounded-sm"
            data-testid="go-back-button"
          >
            Go Back
          </Button>
          <Button
            onClick={() => navigate('/')}
            className="rounded-sm bg-midnight-navy hover:bg-midnight-navy/90"
            data-testid="go-home-button"
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}
